export default "__VITE_ASSET__B5Lm7WGw__"